<template>
<div>
<template v-if="appName ==='FlipPay'">
  <div  @click="$router.push({name:'dashboard'})">
    <img :src="flipLogo" alt="Flippay"/>
    </div>
 </template>
<template v-else-if="appName==='Rello'">
  <div  @click="$router.push({name:'dashboard'})">
    <img :src="relloLogo" alt="Rello" />
    </div>
</template>
</div>

</template>
<script>

export default {
data(){
  return {
    relloLogo: require('@/assets/images/logo/rello-logo.svg'),
    flipLogo: require('@/assets/images/logo/flippay-logo.svg'),
    appName: process.env.VUE_APP_NAME || "FlipPay"
  }
}
}
</script>
